import { ApiProperty } from "@nestjs/swagger";

export class InsuranceTypeRequest {
    @ApiProperty()
    insuranceType: number;
}